@use "../../styles/breakpoint.module.scss" as *;

.grid {
    composes: listReset from "../../styles/composable/utility.module.css";
    composes: gridContainer from "../../styles/composable/layout.module.css";
    row-gap: var(--spacer-40);
}

.item {
    grid-column: span 4;

    @media ($below-tablet) {
        grid-column: span 6;
    }

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}
